export const creditListStyles = { mt: 0.5 };

export const creditRowStyles = { display: 'flex', alignItems: 'center', gap: 0.5 };

export const deleteCreditButtonStyles = { p: 0 };

export const deleteCreditIconStyles = { width: 14, height: 14 };

export const feeNameCellStyles = {
  position: 'relative',
  '& .apply-credit-icon': {
    opacity: 0,
    transition: 'opacity 0.15s',
  },
  '&:hover .apply-credit-icon': {
    opacity: 1,
  },
  '&:hover': {
    zIndex: 1,
  },
};

export const feeNameInputRowStyles = { display: 'flex', alignItems: 'center', gap: 0.5 };

export const feeNameInputFieldWrapperStyles = { flex: 1 };

export const applyCreditIconButtonStyles = { p: 0.25 };

export const applyCreditTooltipPopperProps = { disablePortal: false };
